import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { TrainingPackage } from '../../types/content';
import { BOOKING_URL } from '../../data/site';
import { formatPrice, getCourse } from '../../utils/courses';
import { ButtonLink } from '../ui/ButtonLink';
interface PackageCardProps {
  pkg: TrainingPackage;
  tone?: 'light' | 'dark';
}
export function PackageCard({
  pkg,
  tone = 'light'
}: PackageCardProps) {
  const dark = tone === 'dark';
  const savings = pkg.standard - pkg.price;
  return <article className={`relative flex h-full flex-col rounded-[4px] p-6 lg:p-7 ${dark ? 'bg-white/[0.05] ring-1 ring-chrome-300/20' : 'bg-white ring-1 ring-navy/10 shadow-[0_8px_24px_-14px_rgba(16,32,72,0.3)]'} ${pkg.featured ? dark ? 'ring-2 ring-chrome-300/60' : 'ring-2 ring-navy' : ''}`} data-id="element-488" data-mp="34ou3lz74uo9w">
      <div className="flex items-start justify-between gap-3" data-id="element-489" data-mp="yuu1sutn059s">
        <div data-id="element-490" data-mp="twiw8wadkgxd">
          <p className={`font-display text-sm font-semibold uppercase tracking-[0.12em] ${dark ? 'text-chrome-300' : 'text-steel'}`} data-id="element-491" data-mp="twsj4b04i7yu">Package {pkg.number}</p>
          <h3 className={`t-h3 mt-1 ${dark ? 'text-white' : 'text-navy'}`} data-id="element-492" data-mp="e00w31zv53jy">{pkg.name}</h3>
        </div>
        <span className="shrink-0 rounded-[3px] bg-accent px-2.5 py-1 font-display text-xs font-semibold tracking-wider text-white" data-id="element-493" data-mp="4wzr54mqhihv">
          SAVE {formatPrice(savings)}
        </span>
      </div>
      <p className={`mt-2 text-sm ${dark ? 'text-chrome-300' : 'text-steel'}`} data-id="element-494" data-mp="9xxh43dzjgtx">{pkg.bestFor}</p>
      <ul className="mt-5 space-y-2" data-id="element-495" data-mp="xo1cxokxmcad">
        {pkg.courses.map(slug => {
        const c = getCourse(slug);
        if (!c) return null;
        return <li key={slug} className={`flex items-start gap-2 text-[15px] ${dark ? 'text-chrome-100' : 'text-ink'}`} data-id="element-496" data-mp="nvcbznn0cgta">
              <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? 'text-chrome-300' : 'text-accent'}`} aria-hidden="true" data-id="element-497" data-mp="ssub6mb83ho3" />
              <span data-id="element-498" data-mp="1lazp4a20qy2h">
                <span className="font-semibold" data-id="element-499" data-mp="1lbhqtm7ga4hs">{c.code}</span> — {c.name}
              </span>
            </li>;
      })}
      </ul>
      <div className={`mt-auto pt-6`} data-id="element-500" data-mp="1v6gl1whmgk3m">
        <div className={`flex items-baseline gap-3 border-t pt-5 ${dark ? 'border-white/10' : 'border-navy/10'}`} data-id="element-501" data-mp="1q8ew4uxilqk8">
          <span className={`text-lg line-through ${dark ? 'text-chrome-500' : 'text-steel'}`} data-id="element-502" data-mp="1l898rqya2q7y">
            <span className="sr-only" data-id="element-503" data-mp="1gaqy9w4m42xu">Standard tuition </span>
            {formatPrice(pkg.standard)}
          </span>
          <span className={`font-display text-4xl font-bold ${dark ? 'text-white' : 'text-navy'}`} data-id="element-504" data-mp="1c95qgp6xqeui">
            <span className="sr-only" data-id="element-505" data-mp="17gvt4o3hqci7">Package price </span>
            {formatPrice(pkg.price)}
          </span>
        </div>
        <ButtonLink href={BOOKING_URL} className="mt-4 w-full" ariaLabel={`Buy package ${pkg.number}, ${pkg.name}`} data-id="element-506" data-mp="12ggg5xn4f70r">
          Get This Package
        </ButtonLink>
      </div>
    </article>;
}